import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import { useState } from "react";
import ProductCard from "./components/ProductCard";
import Checkout from "./components/Checkout"
import Thanks from "./components/Thanks"

export const config = {
  endpoint: `https://qkart-backend-5jvk.onrender.com/api/v1`,
};




function App() {
  return (
    <Router>
      <div className="App">
        {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
          <Route exact path="/">
            <Products />
          </Route>
          <Route path="/register">
            <Register />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/checkout">
            <Checkout />
          </Route>
          <Route path="/thanks">
            <Thanks />
          </Route>
      </div>
   </Router>
  );
}

export default App;
